import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import {
  FaUtensils, FaFacebook, FaTwitter, FaInstagram,
  FaLinkedin, FaYoutube, FaTiktok, FaMapMarkerAlt, FaPhone, FaEnvelope
} from 'react-icons/fa';
import './Footer.css';

const SOCIAL_ICONS = {
  facebook: <FaFacebook />, twitter: <FaTwitter />, instagram: <FaInstagram />,
  linkedin: <FaLinkedin />, youtube: <FaYoutube />, tiktok: <FaTiktok />
};

function Footer() {
  const [settings, setSettings] = useState(null);
  const [links, setLinks] = useState([]);

  useEffect(() => {
    axios.get('https://api.hospifylink.com/api/footer/settings')
      .then(r => {
        if (r.data && typeof r.data === 'object' && !Array.isArray(r.data)) {
          setSettings(r.data);
        }
      })
      .catch(() => {});

    axios.get('https://api.hospifylink.com/api/footer/links')
      .then(r => {
        if (Array.isArray(r.data)) setLinks(r.data);
      })
      .catch(() => {});
  }, []);

  const safeLinks = Array.isArray(links) ? links : [];
  const quickLinks = safeLinks.filter(l => l.column_name === 'Quick Links');
  const serviceLinks = safeLinks.filter(l => l.column_name === 'Services');

  const socials = settings ? [
    { key: 'instagram', url: settings.instagram_url },
    { key: 'tiktok', url: settings.tiktok_url }
  ].filter(s => s.url && s.url.trim() !== '') : [];

  const renderBrand = (name = 'HOSPIFY LINK') => {
    const parts = name.split(' ');
    if (parts.length < 2) return name;
    return <>{parts[0]} <span className="footer-accent">{parts.slice(1).join(' ')}</span></>;
  };

  return (
    <footer className="footer-root">
      <div className="footer-grid">
        <div className="footer-col">
          <div className="footer-brand">
            <span>{renderBrand(settings?.brand_name || 'HOSPIFY LINK')}</span>
          </div>
          <p>{settings?.description || 'Premium hospitality staffing services.'}</p>
          <div className="footer-socials">
            {socials.map(s => (
              <a key={s.key} href={s.url} target="_blank" rel="noreferrer" aria-label={s.key}>
                {SOCIAL_ICONS[s.key]}
              </a>
            ))}
          </div>
        </div>

        <div className="footer-col">
          <h4>Quick Links</h4>
          {quickLinks.map(l => (
            l.url?.startsWith('/')
              ? <Link key={l.id} to={l.url}>{l.label}</Link>
              : <a key={l.id} href={l.url || '#'}>{l.label}</a>
          ))}
        </div>

        <div className="footer-col">
          <h4>Services</h4>
          {serviceLinks.map(l => <span key={l.id}>{l.label}</span>)}
        </div>

        <div className="footer-col">
          <h4>Contact</h4>
          {settings?.address && <p><FaMapMarkerAlt /> {settings.address}</p>}
          {settings?.phone && <p><FaPhone /> {settings.phone}</p>}
          {settings?.email && <p><FaEnvelope /> {settings.email}</p>}
        </div>
      </div>
      <div className="footer-bottom">
        © {new Date().getFullYear()} {settings?.copyright_text || 'Hospify Link. All rights reserved.'}
      </div>
    </footer>
  );
}

export default Footer;
